import { DEFAULT_STORAGE_CONFIG, StorageConfigSchema, } from './storage-config-schema.js';
const CONFIG_KEY = 'skjv-storage-config';
export function loadStorageConfig() {
    if (typeof localStorage === 'undefined')
        return DEFAULT_STORAGE_CONFIG;
    const raw = localStorage.getItem(CONFIG_KEY);
    if (!raw)
        return DEFAULT_STORAGE_CONFIG;
    try {
        const parsed = StorageConfigSchema.parse(JSON.parse(raw));
        // Pin scope to the current default so users carrying a stale value
        // (e.g. an older drive.appdata) automatically migrate forward.
        parsed.providers['google-drive'].scope =
            DEFAULT_STORAGE_CONFIG.providers['google-drive'].scope;
        return parsed;
    }
    catch {
        return DEFAULT_STORAGE_CONFIG;
    }
}
export function saveStorageConfig(config) {
    if (typeof localStorage === 'undefined')
        return;
    const parsed = StorageConfigSchema.parse(config);
    localStorage.setItem(CONFIG_KEY, JSON.stringify(parsed));
}
export function clearStorageConfig() {
    if (typeof localStorage === 'undefined')
        return;
    localStorage.removeItem(CONFIG_KEY);
}
//# sourceMappingURL=storage-config-store.js.map